const colordict = [
  ["#e63946",
    "#f1faee",
    "#a8dadc",
    "#457b9d",
    "#1d3557"],
  ["#000000",
    "#14213D",
    "#FCA311",
    "#E5E5E5",
    "#FFFFFF"],
  ["#03045e",
    "#023E8A",
    "#0077B6",
    "#0096C7",
    "#00B4D8",
    "#48CAE4",
    "#90e0ef",
    "#ADE8F4",
    "#CAF0F8"],
  ["#FFCBF2",
    "#F3C4FB",
    "#ECBCFD",
    "#E5B3FE",
    "#E2AFFF",
    "#DEAAFF",
    "#D8BBFF",
    "#D0D1FF",
    "#C8E7FF",
    "#c0fdff"],
  ["#264653",
    "#2A9D8F",
    "#E9C46A",
    "#F4A261",
    "#E76F51"],
  ["#003049", "#d62828", "#f77f00", "#fcbf49", "#eae2b7"],
  ["#f72585", "#b5179e", "#7209b7", "#560bad", "#480ca8", "#3a0ca3", "#3f37c9", "#4361ee", "#4895ef", "#4cc9f0"],
  ["#03071e", "#370617", "#6a040f", "#9d0208", "#d00000", "#dc2f02", "#e85d04", "#f48c06", "#faa307", "#ffba08"],
  ["#0b090a", "#161a1d", "#660708", "#a4161a", "#ba181b", "#e5383b", "#b1a7a6", "#d3d3d3", "#f5f3f4", "#ffffff"],
  ["#0d1b2a", "#1b263b", "#415a77", "#778da9", "#e0e1dd"],
  ["#00296b", "#003f88", "#00509d", "#fdc500", "#ffd500"],
  ["#fadde1", "#ffc4d6", "#ffa6c1", "#ff87ab", "#ff5d8f", "#ff97b7", "#ffacc5", "#ffcad4", "#f4acb7"]
]
export default colordict;